const UPLOAD_STATUSES = {
  NOT_STARTED: 'notStarted',
  POSTING: 'posting',
  VIMEO_UPLOADING: 'vimeoUploading',
  FAILURE: 'failure',
  COMPLETE: 'complete'
};

export default UPLOAD_STATUSES;